module.exports = __webpack_public_path__ + "static/media/visa-creditCard.ed928cd4.svg";